import AppDownloadLinkPanel from '../../components/molecules/panels/AppDownloadLinkPanel'
import GifteeForBusinessIcon from '../../components/atoms/icons/GifteeForBusinessIcon'
import AboutSnsButtons from '../../components/organism/statics/abouts/AboutSnsButtons'
export default {
  components: { AppDownloadLinkPanel, GifteeForBusinessIcon, AboutSnsButtons }
}
